import CompleteSectionForm from '@Components/CompleteSectionForm/CompleteSectionForm';
import { useProgressBar } from 'src/Constant/ProgressBarsContext/ProgressBar.Context';
import { useNatureOfBusinessForm } from '../NatureOfBusinessFormProvider';
import { IIncomeStructureFormValues } from '../NatureOfBusinessFormProvider/types';
import {
  enabledIncomeStructureV2CompletedSectionEn,
  enabledIncomeStructureV2CompletedSectionTh,
} from './utils';
import { Role } from 'src/Enum/Report';

const IncomeStructureCompletedCheckbox = () => {
  const { isPublished } = useProgressBar();
  const { watch, setValue } = useNatureOfBusinessForm();

  const incomeStructure = watch(
    'incomeStructure'
  ) as IIncomeStructureFormValues;

  const completedSection = incomeStructure.completedSection;

  return (
    <CompleteSectionForm
      checkSectionName="incomeStructure.completedSection"
      enableCheckSectionTh={
        !isPublished &&
        enabledIncomeStructureV2CompletedSectionTh(incomeStructure)
      }
      enableCheckSectionEn={
        !isPublished &&
        enabledIncomeStructureV2CompletedSectionEn(incomeStructure)
      }
      onCompleteThChange={(checked) => {
        if (!checked) {
          setValue('incomeStructure.completedSection', {
            ...completedSection,
            isCompletedTh: false,
            roleStampTh: Role.NONE,
            dateTh: undefined,
          });
        }
      }}
      onCompleteEnChange={(checked) => {
        if (!checked) {
          setValue('incomeStructure.completedSection', {
            ...completedSection,
            isCompletedEn: false,
            roleStampEn: Role.NONE,
            dateEn: undefined,
          });
        }
      }}
    />
  );
};

export default IncomeStructureCompletedCheckbox;
